import type { RenderComponentProps, StoreProduct } from "../../../shared/types";

import * as React from "react";

import { createArrayOfLength, filterNulls } from "replo-utils/lib/array";

import { mapStoreProductToReploProduct } from "../../../shared/mappers/product";
import {
  RenderEnvironmentContext,
  RuntimeHooksContext,
  ShopifyStoreContext,
  useRuntimeContext,
} from "../../../shared/runtime-context";
import { mergeContext } from "../../../shared/utils/context";
import { ReploComponent } from "../ReploComponent";

const ProductCollection = ({
  component,
  context,
  extraAttributes,
  componentAttributes,
}: RenderComponentProps) => {
  const {
    activeCurrency: currencyCode,
    activeLanguage: language,
    moneyFormat,
    moneyWithCurrencyFormat,
  } = useRuntimeContext(ShopifyStoreContext);
  const productMetafieldValues =
    useRuntimeContext(RuntimeHooksContext).useShopifyProductMetafieldValues();
  const variantMetafieldValues =
    useRuntimeContext(RuntimeHooksContext).useShopifyVariantMetafieldValues();
  const { isEditorApp } = useRuntimeContext(RenderEnvironmentContext);

  const products: StoreProduct[] = context?.attributes?._products;
  const componentChildren = component.children;
  const componentTemplate = componentChildren?.length && componentChildren[0];

  if (!componentTemplate || (!isEditorApp && !products?.length)) {
    return null;
  }

  const length = products?.length ?? 4;
  const slots = createArrayOfLength(length);

  return (
    <div {...componentAttributes}>
      <>
        {slots.map((index) => {
          const newContext = mergeContext(context, {
            attributes: {
              _products: null,
              _product: products[index] || null,
            },
            state: {
              products: filterNulls(products).map((product) => {
                return mapStoreProductToReploProduct(product, {
                  // TODO (Noah, 2024-03-17): It's weird that we have to pass quantity: 1
                  // here. I'm not even really sure if we use this `state.products` anywhere,
                  // it seems like it would be a footgun since it doesn't account for quantity
                  // or selected variant. We should probably remove it
                  quantity: 1,
                  metafields: {
                    productMetafieldsMapping: productMetafieldValues,
                    variantMetafieldsMapping: variantMetafieldValues,
                  },
                  currencyCode,
                  moneyFormat,
                  moneyWithCurrencyFormat,
                  language,
                });
              }),
            },
          });

          return (
            <ReploComponent
              key={String(index)}
              component={componentTemplate}
              context={newContext}
              extraAttributes={extraAttributes}
            />
          );
        })}
      </>
    </div>
  );
};

export default ProductCollection;
